/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { ScheduleFiltersDataProvider } from "../dataproviders/ScheduleFiltersDataProvider";
import { DataService } from "./DataService";
import { IScheduleFiltersDataService } from "./IScheduleFiltersDataService";
import { IScheduleFiltersEntity } from "sh-models";

/**
 * The Schedule filters data service.
 */
export class ScheduleFiltersDataService extends DataService implements IScheduleFiltersDataService {
    /**
     * Fetch the schedule filters from cache.
     * @param teamId the team id
     * @returns the schedule filters
     */
    public async getScheduleFilters(teamId: string): Promise<IScheduleFiltersEntity> {
        const scheduleFiltersDataProvider = new ScheduleFiltersDataProvider(this.scheduleFiltersDatabase, teamId);
        return await this.loadDataFromCache(scheduleFiltersDataProvider, true);
    }

    /**
     * Set the schedule filters in cache.
     * @param scheduleFilters the schedule filters
     */
    public async setScheduleFilters(scheduleFilters: IScheduleFiltersEntity): Promise<void> {
        const scheduleFiltersDataProvider = new ScheduleFiltersDataProvider(this.scheduleFiltersDatabase, scheduleFilters.teamId);
        await this.updateDataInCache(scheduleFilters, scheduleFiltersDataProvider);
    }

    /**
    * Resets the sync state
    */
    public async resetSyncState() {
    }
}

const service = new ScheduleFiltersDataService();
export default service;